import React, { useState, useEffect, useCallback } from "react";
import { withRouter, Link } from "react-router-dom";
import moment from "moment";
import queryString from "query-string";
import classNames from "classnames";

import { newFetch, GET, POST } from "../../helpers/fetch";

const DeliveryOrder = ({ history, sites, location: { search } }) => {
  const params = queryString.parse(search);
  const associate_id = JSON.parse(localStorage.getItem("user")).id;
  const [assignedList, setAssignedList] = useState("");

  const activeSite = localStorage.getItem("default_site_id")
    ? Number(localStorage.getItem("default_site_id"))
    : null;
  const [defaultSiteData, setDefaultSiteData] = React.useState(null);
  const defaultSiteHandler = () =>
    setDefaultSiteData(sites.find((site) => site.id === activeSite));

  const fetchAssignedDeliveryOrder = async () => {
    let api_path = `/delivery-order/associate/${associate_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setAssignedList(response.data);
    }
  };

  useEffect(() => {
    fetchAssignedDeliveryOrder();
  }, []);

  const CheckWidth = () => {
    if (window.innerWidth > 1000) {
      return ["d-flex", "parentFlex"];
    } else {
      return ["d-flex flex-column ", ""];
    }
  };

  const ReturnChildFlex = () => {
    if (window.innerWidth > 1000) {
      return ["mb-3", "childFlex"];
    } else {
      return ["mb-3 ", ""];
    }
  };

  const [flexName, setFlexName] = useState(CheckWidth);

  const [flexChild, setFlexChild] = useState(ReturnChildFlex);
  let mobileSize = window.innerWidth;
  const setClassName = () => {
    if (mobileSize < 1000) {
      setFlexName(["d-flex flex-column ", ""]);
      setFlexChild(["mb-3 ", ""]);
    } else {
      setFlexName(["d-flex", "parentFlex"]);
      setFlexChild(["mb-3 ", "childFlex"]);
    }
  };

  const handleWindowResize = useCallback((event) => {
    const width = window.innerWidth;

    mobileSize = width;
    setClassName();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);

  React.useEffect(() => {
    sites && defaultSiteHandler();
  }, [sites]);

  return (
    <>
      <div className="container pt-4 d-flex flex-column">
        <div className="rounded-0 mb-0 dashboard__jumbotron-container preferred__label-container">
          <div className="preferred__label-wrapper">
            <div>
              <i
                className="fas fa-arrow-left"
                style={{
                  marginTop: 5,
                }}
                onClick={() => {
                  history.goBack();
                }}
              />
            </div>
            <div
              style={{
                marginLeft: 20,
              }}
            >
              <h4 className="text-brand">Delivery Order</h4>
            </div>
          </div>
          <div
            style={{
              width: 64,
            }}
          >
            <h5>{defaultSiteData?.name || ""}</h5>
            {sites.length > 1 && (
              <p>
                <a href="/site-settings">Change</a>
              </p>
            )}
          </div>
        </div>
        <div
          style={{
            fontSize: "15px",
            fontWeight: "600",
            lineHeight: "20px",
            textAlign: "left",
            color: "#495057",
          }}
          className="pt-5 pb-1"
        >
          Assigned Site:
        </div>
        <div
          style={{
            fontSize: "10px",
            fontWeight: "500",
            lineHeight: "13px",
            textAlign: "left",
            color: "#b7b3b3",
          }}
          className="pb-3"
        >
          {moment().format("dddd, DD MMM YYYY")}
        </div>
        <div className={classNames(flexName)}>
          {assignedList && assignedList.length > 0 ? (
            assignedList.map((item, index) => (
              <div key={index} className={classNames(flexChild) + `mb-3`}>
                <div
                  className="bg-white shadow border rounded mb-3"
                  style={{ border: ".8px solid #dee2e6 !important" }}
                >
                  <div
                    className="imageHover"
                    style={{
                      fontSize: "0.8rem",
                      lineHeight: "1.5",
                      padding: "9px 13px",
                    }}
                    onClick={() =>
                      history.push(`/delivery-order/collect/${item.id}`)
                    }
                  >
                    <span
                      style={{
                        fontWeight: "500",
                        color: "#6399c9",
                      }}
                    >
                      DO No. {item.id}
                    </span>{" "}
                    - {item.site.name},{" "}
                    <small style={{ color: "#d6990e" }}>
                      {" "}
                      ( Signed by: Jenny )
                    </small>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col text-center py-4">
              <h4>No items found</h4>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default withRouter(DeliveryOrder);
